import { createContext, useEffect, useState } from "react";
import { cipher, decipher } from "../Utils";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(() => {
        const savedAuth = sessionStorage.getItem("OGM1ZmVlMmZhZ==");
        return savedAuth
            ? JSON.parse(decipher(atob(decipher(atob(savedAuth)))))
            : null;
    });

    useEffect(() => {
        sessionStorage.setItem(
            "OGM1ZmVlMmZhZ==",
            btoa(cipher(btoa(cipher(JSON.stringify(auth)))))
        );
        sessionStorage.setItem(
            "OJSIioK",
            btoa(cipher(btoa(cipher(JSON.stringify({ status: true })))))
        );
    }, [auth]);

    const logout = () => {
        sessionStorage.removeItem("OGM1ZmVlMmZhZ==");
        sessionStorage.removeItem("OJSIioK");
        setAuth(null);
    };

    useEffect(() => {
        if (!auth) {
            setAuth(null);
        }
    }, [auth]);

    return (
        <AuthContext.Provider value={{ auth, setAuth, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
